var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGroup291(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 59.363,
    height: 53.427,
    viewBox: "0 0 59.363 53.427",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_291",
    "data-name": "Group 291",
    transform: "translate(-1541 -606)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "account_tree_24dp_E8EAED_FILL1_wght400_GRAD0_opsz24",
    d: "M118.586-792.509v-2.968H112.65a5.716,5.716,0,0,1-4.193-1.744,5.717,5.717,0,0,1-1.744-4.192v-23.745h-5.936v2.968A5.717,5.717,0,0,1,99.033-818a5.717,5.717,0,0,1-4.193,1.744h-8.9A5.717,5.717,0,0,1,81.744-818,5.717,5.717,0,0,1,80-822.191v-11.873a5.717,5.717,0,0,1,1.744-4.193A5.717,5.717,0,0,1,85.936-840h8.9a5.717,5.717,0,0,1,4.193,1.744,5.717,5.717,0,0,1,1.744,4.193v2.968h17.809v-2.968a5.717,5.717,0,0,1,1.744-4.193A5.717,5.717,0,0,1,124.522-840h8.9a5.717,5.717,0,0,1,4.193,1.744,5.717,5.717,0,0,1,1.744,4.193v11.873A5.717,5.717,0,0,1,137.619-818a5.717,5.717,0,0,1-4.193,1.744h-8.9A5.717,5.717,0,0,1,120.33-818a5.717,5.717,0,0,1-1.744-4.193v-2.968H112.65v23.745h5.936v-2.968a5.717,5.717,0,0,1,1.744-4.193,5.717,5.717,0,0,1,4.193-1.744h8.9a5.717,5.717,0,0,1,4.193,1.744,5.716,5.716,0,0,1,1.744,4.193v11.873a5.716,5.716,0,0,1-1.744,4.192,5.715,5.715,0,0,1-4.193,1.744h-8.9a5.715,5.715,0,0,1-4.193-1.744A5.716,5.716,0,0,1,118.586-792.509Z",
    transform: "translate(1461 1446)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup291);
export default __webpack_public_path__ + "static/media/Group 291.30d8869effbdc42012be119683289c0d.svg";
export { ForwardRef as ReactComponent };